var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/user_profile_empty_state.e2e5115b.png","uri@2x": __webpack_public_path__ + "static/media/user_profile_empty_state.a2f34a06.png","uri@3x": __webpack_public_path__ + "static/media/user_profile_empty_state.1b854b53.png",
    width: 24,
    height: 24
});